import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="parallax"
export default class extends Controller {
  static values = {
    speed: { type: Number, default: 0.5 }
  }

  connect() {
    this.element.style.willChange = 'transform'
    this.handleScroll = this.handleScroll.bind(this)
    this.ticking = false

    // Set initial transform to ensure image is visible
    this.element.style.transform = 'translate3d(0, 0, 0)'

    window.addEventListener('scroll', this.requestTick.bind(this), { passive: true })

    // Small delay before initial position calculation to ensure layout is ready
    requestAnimationFrame(() => {
      this.handleScroll()
    })
  }

  disconnect() {
    window.removeEventListener('scroll', this.requestTick.bind(this))
  }

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.handleScroll()
        this.ticking = false
      })
      this.ticking = true
    }
  }

  handleScroll() {
    const rect = this.element.getBoundingClientRect()
    const scrolled = window.pageYOffset || document.documentElement.scrollTop
    const windowHeight = window.innerHeight

    // Only apply parallax if element is in or near viewport
    if (rect.top < windowHeight && rect.bottom > 0) {
      // Simple parallax: move slower than scroll
      // Negative value moves up as you scroll down
      const parallaxOffset = scrolled * (this.speedValue / 100)

      this.element.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`
    }
  }
}
